// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vf4cr","selected":"_3TG7R","type1":"O5VMd","type2":"_1ZC4o"};